// External libraries
import { useLayoutEffect, useState } from 'react';
import throttle from 'lodash.throttle';
// @ts-expect-error TODO: Type or global ignore react-components
import { strictIsFinite } from '@checkout/react-components';

const calculateCookieBannerHeight = (): number => {
  const cookieBanner = document.querySelector<HTMLElement>(
    '#cookie-banner-container > div',
  );

  // TODO: Add typing or add local strictIsFinite and remove eslint ignore
  return strictIsFinite(cookieBanner?.offsetHeight)
    ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      cookieBanner!.offsetHeight
    : 0;
};

/**
 * @returns Pixel height of an element, including vertical padding and borders
 */
export const useCookieBannerHeight = (): number => {
  const [calculatedCookieBannerHeight, setCalculatedCookieBannerHeight] =
    useState(calculateCookieBannerHeight());

  useLayoutEffect(() => {
    const handleWindowResize = throttle(() => {
      setCalculatedCookieBannerHeight(calculateCookieBannerHeight());
    }, 200);
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return calculatedCookieBannerHeight;
};
